import React from 'react'
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import '../enterEmail/EnterEmail.css';
import useApi from '../../customHook/useApi';
import { setUserIdEmail } from '../../redux/slices/userSlice';
import { toast } from 'react-toastify';

const EnterEmail = () => {
    const dispatch = useDispatch();
    const { data, error, loading, postFormData } = useApi('https://codezens.com/luststory/index.php/api');
    const [email, setEmail] = useState(null);
    const navigate = useNavigate();

    const handleChange = (event) => {
        setEmail(event.target.value);
    }

    const handleSubmit = () => {
        if (!email) {
            toast.error('Email is required!');
            return;
        }
        // const formData = new FormData();
        // formData.append("email", email);
        // Call the API with the form data
        postFormData('/signup_send_otp', { email: email }).then((response) => {
            if(response && response.status === 1){
                console.log('OTP sent successfully', response);
                dispatch(setUserIdEmail({ id: response.result.user_id, email: response.result.user_id}));
                navigate('/email-verify');
            }
        })
    }
    return (
        <div className='SetupYourProfile-section w-100 position-relative'>
            <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
            <div className='SetupYourProfile-code-box d-flex flex-wrap align-content-center justify-content-center'>
                <div className='inner-SetupYourProfile d-flex flex-wrap align-content-center justify-content-center'>
                    <div className='SetupYourProfile-form w-100'>
                        <h6 className='text-center'>Enter your email to continue</h6>
                        <div className='SetupYourProfile-code-form w-100'>
                            <form action="" className='form-section'>
                                <div className="col-md-12">
                                    <label for="" className="d-none form-label">Email</label>
                                    <input type="email" className="form-control" id="" placeholder="Email" onChange={handleChange} />
                                </div>
                            </form>
                            <p className='text-center mt-4 cursor-pointer' onClick={handleSubmit}>Next</p>
                            {/* <p className='text-center mt-4 cursor-pointer'>
                            <Link rel='stylesheet' to="/email-verify">Next</Link>
                        </p> */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnterEmail